/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef } from 'react';

export default function useHasDiffValue<T = any>(value: T) {
  const prevValue = useRef<T | undefined>();

  useEffect(() => {
    prevValue.current = value;
  }, [value]);

  return prevValue.current !== value;
}
